<div
  *ngIf="authenticatedUser"
  class="user-info"
  [ngClass]="{
    condensed:
      (helperService.inputs$ | async)?.length > 0 ||
      (helperService.buttons$ | async)?.length > 0 ||
      (helperService.condenseProfile$ | async)
  }"
  type="button"
  id="user"
  data-bs-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
>
  <div class="user-avatar">
    <i class="material-symbols-rounded">account_circle</i>
  </div>
  <div class="user-details">
    <div class="user-name">{{ authenticatedUserFullName }}</div>
    <div class="user-role">{{ authenticatedUser | formatUserRole }}</div>
  </div>
  <i class="material-symbols-rounded arrow-icon">keyboard_arrow_down</i>
</div>

<!-- Dropdown menu -->
<div id="dropdownUser" class="dropdown-menu dropdown-notification" aria-labelledby="user" *transloco="let t">
  <ul>
    <div class="dropdown-item disabled">{{ authenticatedUserEmail }}</div>
    <hr />
    <a [routerLink]="links.changePassword()" class="dropdown-item">{{ t('user/passwordChange') }}</a>
    <a *ngIf="!isProduction" href="#" class="dropdown-item">{{ t('shared/editData') }}</a>
    <a (click)="logout()" class="dropdown-item">{{ t('shared/logOut') }}</a>
  </ul>
</div>
